/**
 * Property location lookup — ZIP → state/county and state → county list.
 */
import countiesByState from '../data/countiesByState.json';
import zipCountyCrosswalk from '../data/zipCountyCrosswalk.json';

export function parseZipInput(value) {
  return String(value ?? '').replace(/\D/g, '').slice(0, 5);
}

export function isValidZip(value) {
  return parseZipInput(value).length === 5;
}

export function getCountiesForState(stateCode) {
  const code = String(stateCode || '').toUpperCase();
  return countiesByState[code] || [];
}

/**
 * @returns {{ state: string, counties: string[], primaryCounty?: string } | null}
 */
export function lookupByZip(zipInput) {
  const zip = parseZipInput(zipInput);
  if (zip.length !== 5) return null;
  const hit = zipCountyCrosswalk[zip];
  if (!hit) return null;
  return {
    state: hit.state,
    counties: hit.counties || [],
    primaryCounty: hit.counties?.[0] || null,
  };
}

export function formatLocationAnswerLabel({ propertyZip, propertyState, propertyCounty }) {
  if (propertyZip && propertyState && propertyCounty) {
    return `${propertyCounty}, ${propertyState} ${propertyZip}`;
  }
  if (propertyState && propertyCounty) {
    return `${propertyCounty}, ${propertyState}`;
  }
  if (propertyZip) return propertyZip;
  return '';
}

export function needsCountyDisambiguation(answers) {
  const zip = parseZipInput(answers.propertyZip);
  if (!zip) return false;
  if (answers.propertyCounty) return false;
  const hit = lookupByZip(zip);
  return hit?.counties?.length > 1;
}

export function getCountyOptionsForZip(zipInput) {
  const hit = lookupByZip(zipInput);
  if (!hit?.counties?.length) return [];
  return hit.counties.map((name) => ({ value: name, label: name }));
}

export function getCountyOptionsForState(stateCode) {
  return getCountiesForState(stateCode).map((name) => ({ value: name, label: name }));
}
